import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "./styles.scss";

const MerchantOnboarding = ({ cardText, cardValue }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <div className="queue-card-container">
      <p className="queue-text">{t(`${routeName}.${cardText}`)}</p>
      <p className="queue-length">{cardValue}</p>
    </div>
  );
};

export default MerchantOnboarding;
